import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TestStatus } from "../test/status";

const initialState = {
  status: TestStatus.idle,
};

export const testSlice = createSlice({
  name: "test",
  initialState,
  reducers: {
    start: (state, action) => {
      state.status = TestStatus.ing;
    },
    stop: (state, action) => {
      state.status = TestStatus.idle;
    }
  }
});

export const { start, stop } = testSlice.actions;

export default testSlice.reducer;
